import { getData,  putData,  extractFile, errorHandler } from './index';
import { SET_STAR_IS_LOADING ,
          DOWNLOAD_CONSULTANT_FIELD_IMAGE,
          CONSULTANT_ERROR, 
          FETCH_CONSULTANTS , 
          FETCH_CONSULTANTS_INFOS, 
          FETCH_CONSULTANT, 
          FETCH_CONSULTANT_TEAM,
          FETCH_CONSULTANT_LIST, 
          UPDATE_CONSULTANT, 
          UPDATE_CONSULTANT_PICTURE, 
          EXPORT_CONSULTANTS_LIST,
          EXPORT_CONSULTANT,
          SET_INITIAL_STATE_CONSULTANT,
          LOADING
        } from './types';

//= ===============================
// Consultant actions
//= ===============================

export function fetchConsultants() {
  return async (dispatch) => {
    const url = '/consultant';    
    await dispatch({
      type: LOADING,
    });
    getData(FETCH_CONSULTANTS, CONSULTANT_ERROR, true, url, dispatch);
  } 
}

export function fetchConsultantsInfos() {
  return async (dispatch) => {
    const url = '/consultant/infos';    
    await dispatch({
      type: LOADING,
    });
    getData(FETCH_CONSULTANTS_INFOS, CONSULTANT_ERROR, true, url, dispatch);
  } 
}

export function setStarIsLoading(id) {
  return {
    type: SET_STAR_IS_LOADING,
    payload: id
  }
}

export function fetchConsultant(documentId) {
  return async (dispatch) =>  {
    const url = '/consultant/'+documentId;
    await dispatch({
      type: SET_INITIAL_STATE_CONSULTANT,
      payload: null,
    });
    await dispatch({
      type: LOADING,
    });
    return getData(FETCH_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch);
  };

}

export function getAutocompleteList(documentId) {
    const endpointId = documentId ? documentId : ""
  const url = `/consultant/autocompleteList/${endpointId}`
  return dispatch => getData(FETCH_CONSULTANT_LIST, CONSULTANT_ERROR, true, url, dispatch);
}


export function updateConsultant(document, documentId) {
    const data = { document };
    const url = '/consultant/' +documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function updateFieldConsultant(document, documentId){
    const data = { document };
    const url = '/consultant/updatefield/' +documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function updateFieldImageConsultant(document, file, documentId){
  let data = new FormData()
  
  data.append('file', file)
    Object.keys(document).forEach((key)=>{
        data.append(key, document[key])
  })
    const url = '/consultant/updatefieldimage/' +documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function downloadFieldImageConsultant(getter,documentId) {
    const url = `/consultant/downloadfieldimage/${documentId}?parent=${getter.parent}&index=${getter.index}&name=${getter.name}`;
  return dispatch => extractFile(DOWNLOAD_CONSULTANT_FIELD_IMAGE, CONSULTANT_ERROR, true, url, dispatch);
}


export function addFieldConsultant(document, parent, documentId){
  let data = { document };
  data.parent = parent
    const url = '/consultant/addfield/' +documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function removeFieldConsultant(i, parent, documentId){
  const data = {
    parent : parent,
    index : i
  };
    const url = '/consultant/removefield/' +documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}


export function uploadPicture(file, documentId) {
  let data = new FormData()
  data.append('file', file)
    const url = '/consultant/picture/' +documentId;
  return dispatch => putData(UPDATE_CONSULTANT_PICTURE, CONSULTANT_ERROR, true, url, dispatch, data);
}


export function validate(documentId){
  const data = { };
    const url = '/consultant/validation/validate/' + documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function expire(documentId) {
    const data = {};
    const url = '/consultant/validation/expire/' + documentId
    return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function submit(documentId){
  const data = { };
    const url = '/consultant/validation/submit/' + documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function draft(documentId){
  const data = { };
    const url = '/consultant/validation/draft/' + documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function reject(documentId,rejectReason){
  const data = { rejectReason : rejectReason};
    const url = '/consultant/validation/reject/' + documentId
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function extractConsultant(documentId,languageId){
  return async (dispatch) => {
    const url = `/consultant/extract/${documentId}?languageId=${languageId}`;    
    await dispatch({
      type: LOADING,
    });
    extractFile(EXPORT_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch);
  } 
}

export function getExportConsultantsList(exportVersion,filter) {
    
  return async (dispatch) => {
    const url = filter !== undefined ? `/consultant/export?version=${exportVersion}&filter=${encodeURIComponent(JSON.stringify(filter))}` : `/consultant/export?version=${exportVersion}`;
    await dispatch({
      type: LOADING,
    });
    extractFile(EXPORT_CONSULTANTS_LIST, CONSULTANT_ERROR, true, url, dispatch);
  } 
} 

export function getManagerTeam(managerId){
  const url = '/consultant/manager/' + managerId
  return dispatch => getData(FETCH_CONSULTANT_TEAM, CONSULTANT_ERROR, true, url, dispatch);
}


export function submitField2Approver(documentId,skillPath,validatorId){
  const data = { validator : validatorId,path:skillPath};
  const url = '/consultant/validation/submit_field/' + documentId;
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function approveField(documentId,skillPath,validatorId){
  const data = { validator : validatorId,path:skillPath};
  const url = '/consultant/validation/validate_field/' + documentId;
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function rejectField(documentId,skillPath,validatorId){
  const data = { validator : validatorId,path:skillPath};
  const url = '/consultant/validation/reject_field/' + documentId;
  return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}

export function expireField(documentId, skillPath, validatorId) {
    const data = { validator: validatorId, path: skillPath };
    const url = '/consultant/validation/expire_field/' + documentId;
    return dispatch => putData(UPDATE_CONSULTANT, CONSULTANT_ERROR, true, url, dispatch, data);
}


export function resetError(){
  return dispatch => errorHandler(dispatch,{data:{error:""}},CONSULTANT_ERROR);
}